(function() {
  'use strict';

  angular.module('app.development')
    .service('Development', Development);

  function Development($uibModal) {
    let self = this;

    self = {
      alertExample: alertExample,
      confirmExample: confirmExample
    };

    return self;

    function alertExample(name) {
      let modalInstance = $uibModal.open({
        animation: false,
        templateUrl: 'modules/development/templates/alert.tpl.html',
        controller: 'DialogCtrl',
        size: 'sm',
        resolve: {
          message: function() {
            return 'You triggered the "' + name + '" action!';
          }
        }
      });

      modalInstance.result.then(function() {}, function() {
        console.log('Modal dismissed at: ' + new Date());
      });
    }

    function confirmExample(name) {
      let modalInstance = $uibModal.open({
        animation: false,
        templateUrl: 'modules/development/templates/confirm.tpl.html',
        controller: 'DialogCtrl',
        size: 'sm',
        resolve: {
          message: function() {
            return 'You triggered the "' + name + '" action!';
          }
        }
      });

      modalInstance.result.then(function() {}, function() {
        console.log('Modal dismissed at: ' + new Date());
      });
    }
  }
}());
